const getItemsToRemove = (currentList, newList) => {
  if (!Array.isArray(currentList)) return [];
  if (!Array.isArray(newList)) return currentList;
  return currentList.filter(
    (currentItemId) => newList.indexOf(currentItemId) < 0
  );
};

export default getItemsToRemove;
